module.exports = __webpack_public_path__ + "static/media/portfolio.393fdc50.png";